<template>
    <tab-container
        :id="`page-${model.domId}`"
        :title="model.title"
    >
        <div
            :id="model.domId"
            class="scroll-placeholder"
        />
        <div class="tab-description text-block">
            {{ model.description }}
        </div>
        <div class="charts">
            <generic-section
                v-for="model in model.sectionModels"
                :key="model.id"
                :class="model.colorClass"
                :model="model"
            />
        </div>
    </tab-container>
</template>

<script>
import CategoryModel from '@/model/CategoryModel';
import TabContainer from './TabContainer.vue';
import GenericSection from './GenericSection.vue';

export default {
    components: {
        TabContainer,
        GenericSection
    },
    props: {
        model: {
            type: CategoryModel,
            required: true
        }
    }
};

</script>

<style src="./common.tab.css" scoped></style>
<style lang="postcss" scoped>
.charts {
    @apply block flex-grow w-full justify-start;
}

.header {
    @apply flex-grow-0 text-2xl font-normal;
    max-width: 1100px;
}

.age {
    @apply text-primary-4;
}

.chart {
    @apply flex flex-col mx-auto flex-grow-0 pt-16 p-8;
}
</style>
